import React from 'react'
import styles from './matchCardPlayer.module.scss'
import { Player } from 'types/global'
import Avatar from '../Avatar'
import ConfidenceTick from 'components/generic/ConfidenceTick'
import { getProfileUrl, isPlayerHidden } from 'utils'
import i18n from 'constants/strings'
import { Flag } from 'components/generic/Country'
import classNames from 'classnames'

const icons = {
  flag: ({ player }: { player: Player }) => (
    <Flag alpha3={player.countryCode} className={styles.flag} />
  ),
  avatar: ({ player }: { player: Player }) => (
    <Avatar url={player.avatar} size='xxs' classWrapper={styles.avatar} />
  ),
}

interface Props {
  player: Player
  iconType?: 'flag' | 'avatar'
  truncateName?: boolean
  className?: string
  ariaHidden?: boolean
  showRating: boolean
  showConfidence: boolean
  withLink: boolean
}

const MatchCardPlayer = ({
  player,
  showRating,
  showConfidence,
  withLink,
  iconType = 'avatar',
  truncateName = false,
  className = '',
  ...props
}: Props) => {
  if (!player) return null

  const Icon = icons[iconType]

  return (
    <div className={classNames(styles.wrapper, className)} {...props}>
      <div className={styles.iconContainer}>
        <Icon player={player} />
      </div>
      <div className={styles.playerInfoContainer}>
        <p className={classNames(styles.infoPlayer)}>
          {isPlayerHidden(player) ? (
            i18n.t('strData.optOutPlayerName')
          ) : withLink ? (
            <a href={getProfileUrl(player.id)} className={styles.fullname}>
              {truncateName && player.firstName && player.lastName
                ? `${player.firstName.charAt(0)}. ${player.lastName}`
                : player.fullName}
            </a>
          ) : (
            <span className={styles.fullname}>
              {truncateName && player.firstName && player.lastName
                ? `${player.firstName.charAt(0)}. ${player.lastName}`
                : player.fullName}
            </span>
          )}
          {showRating && (
            <span className={styles.wtn}>
              {player.contemporaryWtn ||
                (player.isRanked ? i18n.t('strData.pro') : i18n.t('strData.na'))}
            </span>
          )}
          {showConfidence && (
            <ConfidenceTick
              className={styles.confidence}
              score={player.contemporaryWtnConfidence}
            />
          )}
        </p>
      </div>
    </div>
  )
}

export default MatchCardPlayer
